import { Link } from 'react-router-dom';



function BreadCumbcat() {
  return (
    <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundColor: '#F5CFE8' }} 
    // style={{backgroundImage:'url("img/bg/dogcat.jpg")'}}
    >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h2 className="title">Listes des produits </h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Acceuil</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Liste produits</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
	  
  )
}

export default BreadCumbcat;
